<template>
  <div class="flex flex-col gap-2 border-t border-line pt-2">
    <div class="flex items-center gap-2">
      <div
        class="tag-chip tag-tint"
        :style="{ '--tag-color': `#${previewColor}` }"
        :title="name"
        @click="confirm"
      >
        <span class="truncate">{{ name }}</span>
        <i class="tr tr-plus text-[0.5rem]"></i>
      </div>
    </div>

    <div class="flex flex-wrap items-center gap-1.5">
      <span class="mr-0.5 shrink-0 text-label text-muted">{{ t('settings.Pick_a_color') }}</span>
      <button
        v-for="swatch in LABEL_COLORS"
        :key="swatch"
        type="button"
        class="size-5 shrink-0 cursor-pointer rounded-chip border-0 p-0 outline-2 outline-offset-2
               transition-[outline-color] duration-150"
        :class="swatch === color ? 'outline-accent' : 'outline-transparent'"
        :style="{ background: `#${swatch}` }"
        @mouseenter="hovered = swatch"
        @mouseleave="hovered = null"
        @click.stop="emit('create', { name, color: swatch })"
      ></button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { LABEL_COLORS, labelColorFor } from '@/utils/tagColors';

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['create']);

const { t } = useI18n();

const hovered = ref(null);

// the palette pick the rest of the app already derives from a name, so it shifts
// with every keystroke while staying stable for a given name
const color = computed(() => labelColorFor(props.name));

const previewColor = computed(() => hovered.value || color.value);

function confirm() {
  emit('create', { name: props.name, color: color.value });
}

defineExpose({ confirm });
</script>
